import React from 'react'
import { Link } from 'react-router-dom'
import HeroCarousel from '../components/HeroCarousel'
import { useConfig } from '../contexts/ConfigContext'

const Home = () => {
  const { config, loading } = useConfig()

  if (loading) {
    return (
      <div className="pt-16 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">加载中...</p>
        </div>
      </div>
    )
  }

  const siteName = config?.site?.name || '无锡市摩恒科技有限公司'
  const siteDescription = config?.site?.description || '专业科技解决方案提供商'
  const contactEmail = config?.site?.contact_email || 'info@wxmhkj.cn'
  const contactPhone = config?.site?.contact_phone || '0510-XXXXXXX'
  const companyAddress = config?.site?.company_address || '江苏省无锡市'
  return (
    <div className="pt-16">
      {/* Hero Section with Carousel */}
      <section className="relative">
        <HeroCarousel />
        
        {/* Hero Content Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl mx-auto px-4">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 fade-in">
              创新科技
              <span className="block text-primary-light">引领未来</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 fade-in" style={{animationDelay: '0.3s'}}>
              {siteName} - {siteDescription}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center fade-in" style={{animationDelay: '0.6s'}}>
              <Link to="/products" className="btn-primary text-lg px-8 py-3">
                探索产品
              </Link>
              <Link to="/company" className="btn-secondary text-lg px-8 py-3">
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section-padding bg-white">
        <div className="container-max">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-tech mb-4">
              我们的优势
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              凭借多年的技术积累和行业经验，我们为客户提供全方位的科技技术解决方案
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center card p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-tech mb-4">技术领先</h3>
              <p className="text-gray-600">
                采用最新技术架构，硬件解决方案，确保产品性能卓越，满足未来技术发展需求
              </p>
            </div>

            <div className="text-center card p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-tech mb-4">高效性能</h3>
              <p className="text-gray-600">
                优化系统架构，提供超强数据能力，提供快速响应和稳定可靠的服务体验
              </p>
            </div>

            <div className="text-center card p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-tech mb-4">专业团队</h3>
              <p className="text-gray-600">
                拥有扎实的技术、经验丰富的技术团队，为客户提供专业的技术支持和服务
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-primary">
        <div className="container-max text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            准备好开始合作了吗？
          </h2>
          <p className="text-xl text-primary-light mb-8 max-w-2xl mx-auto">
            联系我们，了解我们的产品如何帮助您的业务实现数字化技术转型
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/products" className="bg-white text-primary hover:bg-gray-100 font-medium py-3 px-8 rounded-lg transition-colors duration-200">
              查看产品
            </Link>
            <Link to="/downloads" className="border-2 border-white text-white hover:bg-white hover:text-primary font-medium py-3 px-8 rounded-lg transition-colors duration-200">
              下载资料
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
